import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import es from 'vuetify/lib/locale/es'
import pt from 'vuetify/lib/locale/pt'

Vue.use(Vuetify);

export default new Vuetify({
    lang:{
        locales:{es, pt},
        current: localStorage.getItem("locale") || 'es'
    }
});
